import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/dashboard/Dashboard'
import DashboardIndex from '@/components/dashboard/index/DashboardIndex'
import Front from '@/components/front/Front'
import Signin from '@/components/front/Signin'
import Stations from '@/components/dashboard/stations/Stations'
import Station from '@/components/dashboard/stations/station/Station'
import Organizations from '@/components/dashboard/organizations/Organizations'
import OrganizationContainer from '@/components/dashboard/organizations/organization/OrganizationContainer'
import OrganizationsContainer from '@/components/dashboard/organizations/user/Container'
import SignUp from '@/components/front/Signup'
import ForgotPassword from '@/components/front/ForgotPassword'
import Container from '@/components/shared/Container'
import User from '@/components/dashboard/users/user/User'
import SaldoAndCredit from '@/components/dashboard/saldoAndCredit/SaldoAndCredit'
import AccessStation from '@/components/dashboard/stations/AccessStation'
import Countries from '@/components/dashboard/countries/Countries'
import Currencies from '@/components/dashboard/currencies/Currencies'
import Profile from '@/components/dashboard/profile/Profile'
import ResetPassword from '@/components/front/ResetPassword'
import Organization from '@/components/dashboard/organizations/user/organization/UserOrganization'
import AdminOrganization from '@/components/dashboard/organizations/organization/Organization'
import SystemStations from '@/components/dashboard/stations/system/SystemStations'
import BillingOverview from '@/components/dashboard/billing-overview/BillingOverview'
import Users from '@/components/dashboard/users/Users'
import Invoice from '@/components/front/invoice/Invoice'

Vue.use(Router)

export default new Router({
  mode: process.env.ROUTER_MODE,
  routes: [
    {
      path: '/',
      component: Front,
      children: [
        {
          path: '',
          name: 'Signin',
          component: Signin,
          meta: { requiresAuth: false, compact: false }
        },
        {
          path: '/invoice/:id',
          name: 'Invoice',
          component: Invoice,
          meta: { invoice: true }
        },
        {
          path: '/signup',
          name: 'SignUp',
          component: SignUp,
          meta: { requiresAuth: false, compact: true }
        },
        {
          path: '/forgot',
          name: 'Forgot',
          component: ForgotPassword,
          meta: { requiresAuth: false, compact: false }
        },
        {
          path: '/reset/:uid',
          name: 'Reset',
          component: ResetPassword,
          meta: { requiresAuth: false, compact: false }
        }
      ]
    },
    {
      path: '/dashboard',
      component: Dashboard,
      meta: { requiresAuth: true, breadcrumb: 'Dashboard' },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: DashboardIndex
        },
        {
          path: 'transactions',
          name: 'SaldoAndCredit',
          component: SaldoAndCredit,
          meta: { breadcrumb: 'Saldo and credit' }
        },
        {
          path: 'organizations',
          component: Container,
          meta: { breadcrumb: 'Organizations' },
          children: [
            {
              path: '',
              name: 'Organizations',
              component: OrganizationsContainer
            },
            {
              path: ':orgId',
              name: 'Organization',
              meta: { breadcrumb: 'Organization' },
              component: Organization
            },
            {
              path: ':orgId/member/:id',
              name: 'OrganizationMember',
              meta: { breadcrumb: 'Member' },
              component: User
            }
          ]
        },
        {
          path: 'stations',
          component: Container,
          meta: { breadcrumb: 'Stations' },
          children: [
            {
              path: '',
              name: 'stations',
              component: Stations
            },
            {
              path: ':sId',
              name: 'Station',
              meta: { breadcrumb: 'Station' },
              component: Station
            },
            {
              path: ':sId/access',
              name: 'AccessStation',
              component: AccessStation
            }
          ]
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
        },
        {
          path: 'admin/organizations/:orgId',
          name: 'AdminOrganization',
          component: AdminOrganization
        },
        {
          path: 'system',
          component: Container,
          meta: { requiresSystem: true },
          children: [
            {
              path: 'organizations',
              name: 'SystemOrganizations',
              component: Organizations
            },
            {
              path: 'organizations/:orgId',
              name: 'OrganizationBySystem',
              component: AdminOrganization
            },
            {
              path: 'stations',
              name: 'allStations',
              component: SystemStations
            },
            {
              path: 'users',
              name: 'users',
              component: Users
            },
            {
              path: 'users/:id',
              name: 'User',
              component: User
            },
            {
              path: 'countries',
              name: 'Countries',
              component: Countries
            },
            {
              path: 'currencies',
              name: 'Currencies',
              component: Currencies
            },
            {
              path: 'billing',
              name: 'Billing',
              component: BillingOverview
            }
          ]
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js